import IsMobile from "ismobilejs"
import $ from "jquery"

class recipeDetailComponent {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("recipeDetailComponent::initialize()")

		$("#bb-footer").addClass("has-cookmode")

		this._waShareLinkFix()
		this._cookModeButtonPosition()
	}
	_waShareLinkFix() {
		if (!(IsMobile().any && IsMobile().other.firefox)) return

		document.querySelectorAll(".bb-link--share--whatsapp").forEach((item) => {
			item.href = item.href.replace("https://api.whatsapp.com/", "whatsapp://")
		})
	}

	_cookModeButtonPosition() {
		if ("IntersectionObserver" in window) {
			let previousY = 0

			const separatorObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						const currentY = entry.boundingClientRect.y
						if (entry.isIntersecting) {
							if (currentY < previousY) {
								$(".bb-cookmode__button-container").addClass("sticky-bottom")
							}
						} else {
							if (currentY > previousY) {
								$(".bb-cookmode__button-container").removeClass("sticky-bottom")
							}
						}

						previousY = currentY
					})
				},
				{ rootMargin: "0px 0px 0px 0px" },
			)
			$(".bb-separator").each((i, separator) => {
				separatorObserver.observe(separator)
			})
		}
	}
}

export default recipeDetailComponent
